import { render, staticRenderFns } from "./EditorModify.vue?vue&type=template&id=01078b00"
import script from "./EditorModify.vue?vue&type=script&lang=js"
export * from "./EditorModify.vue?vue&type=script&lang=js"
import style0 from "./EditorModify.vue?vue&type=style&index=0&id=01078b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports